import { SVGProps } from 'react';

export const SvgMaquillaje = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.2803 0.21967C21.5732 0.512563 21.5732 0.987437 21.2803 1.28033L1.28033 21.2803C0.987437 21.5732 0.512563 21.5732 0.21967 21.2803C-0.0732233 20.9874 -0.0732233 20.5126 0.21967 20.2197L20.2197 0.21967C20.5126 -0.0732233 20.9874 -0.0732233 21.2803 0.21967Z"
    />
    <path d="M0.00189972 2.54327C0.0241638 1.87701 0.297936 1.24392 0.76813 0.771366C1.23974 0.30124 1.87192 0.0271928 2.53744 0.00437179C3.20296 -0.0184492 3.85242 0.211651 4.35513 0.648367L13.6245 8.81488L12.2074 10.2319L3.03713 2.15137C2.91596 2.04902 2.76068 1.99607 2.60223 2.00304C2.44377 2.01002 2.29375 2.07641 2.18204 2.18901C2.07033 2.3016 2.00512 2.45214 1.99939 2.61064C1.99366 2.76915 2.04784 2.924 2.15113 3.04437L10.2282 12.2111L8.81185 13.6275L0.64813 4.36237C0.210533 3.85948 -0.0203643 3.20952 0.00189972 2.54327Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.80548 14.7552L13.1301 18.5284C13.5701 20.8634 14.8711 24.0004 17.5971 24.0004C19.2939 23.9985 20.9207 23.3236 22.1206 22.1238C23.3204 20.924 23.9953 19.2972 23.9971 17.6004C23.9971 14.8754 20.8611 13.5734 18.5261 13.1334L14.7522 9.80845L9.80548 14.7552ZM13.8561 16.3274L16.3241 13.8594L14.3191 12.0924L12.0891 14.3224L13.8561 16.3274ZM20.7069 20.7102C21.5318 19.8853 21.9958 18.7669 21.9971 17.6004C21.9971 16.0924 19.3581 15.3144 17.9471 15.0634L15.0601 17.9514C15.3101 19.3614 16.0891 22.0004 17.5971 22.0004C18.7637 21.999 19.8821 21.535 20.7069 20.7102Z"
    />
  </svg>
);
